window.BgVegas = {
	init: () => {
		let $bg = $('[data-bg]');

		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = BgVegas.changeSliderCover($self), //$self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				if (bg === 'colored') {
					let code = $self.data('code');
					$self.css({
						'background-color': code
					})
				} else {
					$self.css({
						'background-image': 'url(' + bg + ')',
						'background-position': position,
						'background-repeat': repeat,
						'background-size': size,
						'background-attachment': attachment
					});
				}
			});
		}
	},
	hexToRgbA: (hex, opacity = 1) => {
		let c;
		
		if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
			c = hex.substring(1).split('');
			if(c.length === 3){
				c = [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c = '0x' + c.join('');
			return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + opacity + ')';
		}
	},
	changeSliderCover: function (slide) {
		//let slide = $('.vg-slider .slide');

		let slideBg = '';
		if (window.matchMedia("(max-width: 450px)").matches && $(slide).attr('data-bg320')) {
			slideBg = $(slide).attr('data-bg320');
		} else if (window.matchMedia("(max-width: 580px)").matches && $(slide).attr('data-bg480')) {
			slideBg = $(slide).attr('data-bg480');
		} else if (window.matchMedia("(max-width: 800px)").matches && $(slide).attr('data-bg800')) {
			slideBg = $(slide).attr('data-bg800');
		} else if (window.matchMedia("(max-width: 1024px)").matches && $(slide).attr('data-bg1024')) {
			slideBg = $(slide).attr('data-bg1024');
		} else {
			slideBg = $(slide).attr('data-bg');
		}

		return slideBg;
	}
};

$(document).ready(function () {
	BgVegas.init();

	$(window).resize(function () {
		let $bg = $('[data-bg]');

		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
				$bg = BgVegas.changeSliderCover($self);

				$self.css('background-image', 'url(' + $bg + ')');

			});
		}
	});
});
